module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-900-black-italic-ce1cb6a14749258f0ae08271c02618ec.woff";